import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.workOrder

// 销售资金池信息
export function updateChanceType(data) {
    return request({
        url: serviceName + `/sale/update_chance_type`,
        method: 'post',
        data: data
    })
}

// 是否需要cto调整人工成本
export function ctoUpdate(data) {
    return request({
        url: serviceName + `/sale/cto_update`,
        method: 'post',
        data: data
    })
}

// cto保存人工成本
export function ctoSave(data) {
    return request({
        url: serviceName + `/sale/cto_save`,
        method: 'post',
        data: data
    })
}

// 表单控件「商机」下拉选项（stage>0 且 stage<11）；params.scope='mine' 时仅返回当前登录用户归属的商机
export function getSaleChanceOptions(params) {
    return request({
        url: serviceName + `/sale/chance_options`,
        method: 'get',
        params
    })
}

// 表单控件「项目」下拉选项（apply_state in (2,5,6,7)）；params.scope='mine' 时仅返回当前登录用户归属的项目
export function getSaleProjectOptions(params) {
    return request({
        url: serviceName + `/sale/project_options`,
        method: 'get',
        params
    })
}

